import {ReactComponent as StarSvg} from '../img/emojis/star.svg'
import emptyStarIcon from '../img/emojis/emptystar.svg'
import React from 'react'
import styled, {keyframes} from 'styled-components'
import classNames from 'classnames'

const pop = keyframes`
  from {
    transform: scale(1);
  }

  50% {
    transform: scale(2.5);
  }

  to {
    transform: scale(1);
  }
`

const StyledImg = styled.img`
  width: 1.5em;
  ${props => props.unanswered && `
    opacity: 0.4;
  `}
`
const StyledStar = styled(StarSvg)`
  width: 1.5em;

  #color polygon {
    fill: rgba(0,0,0,0);
    transition: fill 1s;
  }
  &.correct {
    animation: ${pop} 1s;
    
    #color polygon {
      transition: fill 1s;
      fill: rgb(252, 234, 43);
    }
  }
  &.wrong #color polygon {
    transition: fill 1s;
    fill: #777;
  }
`

const Star = ({correct}) => {

  
  const unanswered = correct === null

  return (
    <StyledStar className={classNames({correct:correct, wrong:correct===false})} />
  )
}



export default Star
